import { render, staticRenderFns } from "./WexameList.vue?vue&type=template&id=962998b8&scoped=true&"
import script from "./WexameList.vue?vue&type=script&lang=js&"
export * from "./WexameList.vue?vue&type=script&lang=js&"
import style0 from "./WexameList.vue?vue&type=style&index=0&id=962998b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962998b8",
  null
  
)

export default component.exports